import { IntlShape } from 'react-intl';
import { DataEntry } from 'models/data';

export interface NamedAndOtherAwareDataEntryHolder {
  name: string;
  entry: DataEntry;
  isOther: boolean;
}

export const getArrayWithIsOthers = <T extends NamedAndOtherAwareDataEntryHolder>(
  allCountries: T[],
  measures: string[],
  intl: IntlShape,
  finaliseOthers?: (others: T, countOthers: number) => T
) => {
  const standard = allCountries.filter(c => !c.isOther);
  const isOthers = allCountries.filter(c => c.isOther);

  if (isOthers.length > 0) {
    let grouped = allCountries
      .filter(c => c.isOther)
      .reduce((acc, current) => {
        const measureEntries: Record<string, number> = measures
          .map(m => ({
            [m]: acc.entry.values[m] + current.entry.values[m],
          }))
          .reduce((l, r) => ({ ...l, ...r }));
        const compareMeasureEntries: Record<string, number> =
          acc.entry.compareValues && current.entry.compareValues
            ? measures
                .map(m => ({
                  [m]: acc.entry.compareValues ? acc.entry.compareValues[m] + current.entry.compareValues[m] : 0,
                }))
                .reduce((l, r) => ({ ...l, ...r }))
            : {};
        return {
          ...acc,
          entry: {
            ...acc.entry,
            values: {
              ...acc.entry.values,
              ...measureEntries,
            },
            compareValues: {
              ...acc.entry.values,
              ...compareMeasureEntries,
            },
          },
        };
      });

    // reducing a single element returns the element, meaning any of the below changes would change the original
    // let's create a copy to avoid this edge case
    grouped = { ...grouped };

    grouped.name = intl.formatMessage({
      id: 'groupby.others',
      defaultMessage: 'Others',
    });
    if (finaliseOthers) {
      grouped = finaliseOthers(grouped, isOthers.length);
    }
    return [...standard, grouped];
  }

  return standard;
};
